import { createApiClient, getApiBaseUrl } from './httpClient';

// Get API base URL based on environment and development model
// Development environment information
const getEnvironmentInfo = () => {
  const baseUrl = getApiBaseUrl();
  const isDevelopment = baseUrl.includes('localhost');
  const isLocalDB = baseUrl.includes(':3000') && process.env.REACT_APP_DB_MODE === 'local';
  const isProductionTest = baseUrl.includes('ondigitalocean.app');
  
  let mode = 'Production';
  if (isDevelopment) {
    mode = isLocalDB ? 'Local Development (Local DB)' : 'Local Development (Cloud DB)';
  } else if (isProductionTest) {
    mode = 'Production Testing';
  }
  
  return {
    baseUrl,
    isDevelopment,
    isLocalDB,
    isProductionTest,
    mode
  };
};

const API_BASE_URL = getApiBaseUrl();
const ENVIRONMENT_INFO = getEnvironmentInfo();

// Log environment info in development
if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_DEBUG === 'true') {
  console.log('🌐 React Admin Environment:', ENVIRONMENT_INFO);
}

const apiClient = createApiClient(API_BASE_URL);

export default apiClient;
export { ENVIRONMENT_INFO };
